// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccountVerificationPending-module__wrapper___1beyG","spinner":"AccountVerificationPending-module__spinner___1I-MN"};